import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d1e6c15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-history-row-container" }
const _hoisted_2 = { class: "status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["book-history-row-wrapper", { canceled: $setup.canceled, expired: $setup.expired, 'no-show': $setup.noShow }])
    }, [
      _createVNode($setup["BookHistoryInfo"], {
        bookInfo: $props.bookInfo,
        isCanceled: $props.bookInfo.bookStatus === $setup.BookStatusName.CANCEL
      }, null, 8 /* PROPS */, ["bookInfo", "isCanceled"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString($props.bookInfo.bookStatus), 1 /* TEXT */)
    ], 2 /* CLASS */)
  ]))
}